import React, { useState, useEffect } from 'react';
import { UserPlus, Calendar, User, Clock, Share2, BookOpen, Shield, AlertTriangle, Phone, Scale, CheckCircle, Users, FileText, TrendingUp } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPost6 = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] py-12 sm:py-20 mt-20">
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center text-white">
          <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
            <BookOpen className="w-4 h-4 sm:w-6 sm:h-6" />
            <span className="text-white font-semibold text-sm sm:text-base">المدونة القانونية</span>
          </div>
          
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight px-2 text-white">
            التعديلات الجديدة في نظام العمل
          </h1>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-white text-sm sm:text-base">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>ديسمبر 2025</span>
            </div>
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>شركة أنس للمحاماة</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>18 دقيقة قراءة</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-16">
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg overflow-hidden">
          
          {/* Article Header */}
          <div className="p-4 sm:p-8 border-b border-gray-100">
            <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <p className="text-sm sm:text-base md:text-lg text-[#0a3a23] font-semibold">
                <strong>إشراف: شركة أنس للمحاماة والاستشارات القانونية</strong>
              </p>
            </div>
          </div>

          {/* Introduction */}
          <div className="p-4 sm:p-8">
            <div className="mb-6 sm:mb-8">
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                شهدت المملكة مؤخراً تعديلات في لائحة نظام العمل، وذلك نظراً لأهمية قطاع الأعمال في المملكة، وتشمل تعديل 38 مادة وإلغاء 7 مواد وإضافة مادتين، وذلك بهدف حماية حقوق العاملين وتحسين بيئة العمل وتحفيز توظيف السعوديين وزيادة التنافسية في بيئة العمل ودعم المرأة العاملة، بالإضافة إلى العديد من الأهداف الأخرى التي تسهم في إرساء بيئة عمل أكثر مرونة وعدالة.
              </p>
              
              <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                فقد أعلنت وزارة الموارد البشرية والتنمية الاجتماعية عن بدء سريان تعديلات نظام العمل اعتباراً من يوم الأربعاء 1446/8/20هـ الموافق 2025/2/19م، وذلك استناداً إلى قرار مجلس الوزراء رقم (117) الصادر بتاريخ 1446/2/2هـ، بناءً على المرسوم الملكي رقم (44) بتاريخ 1446/2/8هـ، بهدف تعزيز الاستقرار الوظيفي، ورفع كفاءة سوق العمل لتلبية احتياجات القطاع الخاص.
              </p>
            </div>

            {/* Section 1: المصطلحات الجديدة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <FileText className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">ما هي المصطلحات الجديدة المضافة في نظام العمل؟</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الاستقالة</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">من بين التعديلات المهمة التي تم إدخالها في نظام العمل هي إضافة تعريف واضح للاستقالة وأصبح لها تشريع محدد يدعم شرعيتها في النظام ويدعم حقوق العامل والمساواة في بيئة العمل، فقد تم تعريف الاستقالة بأنها طلب مكتوب يقدمه العامل إلى صاحب العمل في عقد محدد المدة دون أي شرط أو قيد أو إكراه، ويوافق عليها صاحب العمل خلال مدة محددة.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">الاسناد</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">يتيح مفهوم "الاسناد" للمنشآت المرخصة أن تقدم عمالة مؤهلة للعمل لدى جهات أخرى، بمعنى توفير عامل للعمل لدى غير صاحب العمل وذلك من خلال منشأة مرخص لها لهذا الغرض، وهذا ما يعزز المرونة في تنظيم القوى العاملة.</p>
                </div>
              </div>
            </div>

            {/* Section 2: تعديلات العامل غير السعودي */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل الجديدة للعامل غير السعودي</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>وفقاً لما ورد في المادة 37 من النظام فإنه يجب أن يكون عقد عمل غير السعودي مكتوباً ومحدد المدة، وإذا خلا العقد من بيان مدته يعتبر عقده سارياً لمدة سنة من تاريخ مباشرته للعمل الفعلية، وليس مرتبطاً بتاريخ انتهاء رخصة إقامته كما في النظام السابق وإذا استمر العمل بعد انتهاء هذه المدة عُد متجدداً لمدة مماثلة.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>وفقاً لما ورد في المادة 40 من نظام العمل فقد حدد النظام غرامة تأخير تجديد الإقامة للعامل غير السعودي، حيث يجب على صاحب العمل دفع هذه الغرامة في حال كان التقصير من طرفه.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 3: التدريب والتأهيل */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <TrendingUp className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل في مرحلة التدريب والتأهيل للموظفين</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>وفقاً للمادة 42 فقد أوجبت المادة على كل منشأة بوضع سياسة للتدريب عمالها السعوديين وتأهيلهم.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>إلزامية توثيق عقود التدريب والتأهيل عبر منصة قوى.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>يستطيع صاحب العمل التعاقد مع المتدرب وتسجيله في منشأته، أو التعاون مع جهات أخرى لتنفيذ التدريب.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>يجب توضيح المهارات التي سيكتسبها المتدرب في عقد التدريب.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>للمتدرب التمتع بذات حقوق الموظف من حيث الإجازات والمكافآت والتعويضات.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>لا يجوز إنهاء عقد التدريب إلا بتقارير تقويم دورية، ولا يمكن لأي من الطرفين المطالبة بالتعويض إلا إذا تضمن العقد حكماً بذلك.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 4: فترة التجربة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل في فترة التجربة</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  سابقاً كانت فترة التجربة 90 يوماً مع إمكانية تمديدها حتى 180 يوماً، أما في التعديلات الجديدة فقد تم تحديد فترة التجربة لتكون مباشرة 180 يوماً كحد أقصى ويتم تحديدها بشكل واضح في العقد دون الحاجة لإعادة الاتفاق على التمديد.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  كما سمح النظام بالتنازل عن فترة التجربة نهائياً، وأصبح بالإمكان لكل من الطرفين إنهاء العقد خلال هذه المدة سواء تم فسخ عقد العمل خلال هذه الفترة من قبل العامل أو صاحب العمل، وتم إلغاء حق الإنهاء من طرف واحد.
                </p>
              </div>
            </div>

            {/* Section 5: توحيد نماذج العقود */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Scale className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">التعديلات الجديدة في توحيد نماذج عقود العمل</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  بين النظام في التعديلات الجديدة ما يخص توحيد نماذج عقود العمل والتي تلزم أصحاب الأعمال التقيد بها، فقد ذكرت المادة 52 من النظام أن الوزارة تحدد نموذجاً موحداً لكل نوع من أنواع عقود العمل مهما كان نوع العقد.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  يتضمن العقد بصورة أساسية على اسم صاحب العمل ومكانه واسم العامل وجنسيته وما يلزم لإثبات شخصيته وعنوان إقامته والأجر المتفق عليه بما في ذلك المزايا والبدلات ونوع العمل ومكانه وتاريخ الالتحاق به ومدة العقد إن كان محدد المدة وحقوق كل طرف والتزاماته الأساسية.
                </p>
              </div>
            </div>

            {/* Section 6: توثيق عقود العمل */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <FileText className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل في توثيق عقود العمل</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  ألزمت التعديلات الجديدة في نظام العمل أن يكون توثيق عقود العمل إلكترونياً عبر منصة قوى، ولم يعد هناك توثيق ورقي مثل ما كان عليه في النظام السابق.
                </p>
              </div>
            </div>

            {/* Section 7: واجبات صاحب العمل */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">التعديلات على واجبات صاحب العمل المضافة للمادة 61</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>أن يمتنع عن القيام بكل ما من شأنه إبطال أو إضعاف تطبيق تكافؤ الفرص أو المعاملة في الاستخدام والمهنة، سواء من خلال الاستبعاد أو التفريق أو التفضيل بين المتقدمين للعمل أو العاملين لديه على أساس العرق أو اللون أو الجنس أو السن أو الإعاقة أو الحالة الاجتماعية أو أي شكل من أشكال التمييز الأخرى.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>أن يوفر السكن اللائق لعماله، وله أن يستعيض عن ذلك ببدل نقدي مناسب يدفعه لهم مع الأجر.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>أن يوفر وسيلة مواصلات مناسبة لعماله من مقر سكنهم إلى مقر العمل، وله أن يستعيض عن ذلك ببدل نقدي مناسب يدفعه لهم مع الأجر.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 8: الجزاءات التأديبية */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <AlertTriangle className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل في الجزاءات التأديبية المادة 72</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  عدلت المادة لتكون بالنص الآتي: يجب أن يبلغ العامل بقرار توقيع الجزاء عليه كتابة، فإذا امتنع عن الاستلام أو كان غائباً يرسل البلاغ بكتاب مسجل على عنوانه المبين في ملفه وله التظلم للجهة المختصة لدى صاحب العمل خلال (ثلاثين) يوماً – عدا أيام العطل الرسمية – من تاريخ إبلاغه بالقرار، فإن رفض تظلمه أو لم يبت فيه كتابة خلال (خمسة عشر) يوماً من تقديمه كان له حق الاعتراض أمام المحاكم العمالية على القرار الخاص بتوقيع الجزاء عليه خلال (ثلاثين) يوم من تاريخ رفض تظلمه أو انتهاء المدة المحددة للبت في التظلم أيهما أقرب.
                </p>
              </div>
            </div>

            {/* Section 9: إنهاء عقد العمل غير محدد المدة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">التعديلات الجديدة في إنهاء عقد العمل غير محدد المدة</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  وفقاً للمادة 75 من نظام العمل الجديد إذا كان الأجر يُدفع شهرياً فإنه يحق لأي من الطرفين إنهاء العقد بناء على سبب مشروع وفقاً للتالي:
                </p>
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>إذا كان الإنهاء من طرف العامل فيجب عليه توجيه إشعار كتابي لصاحب العمل قبل 30 يوماً على الأقل من تاريخ الإنهاء، بعد أن كانت المدة 60 يوماً في النظام السابق.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>إذا كان الإنهاء من طرف صاحب العمل فإنه يجب عليه توجيه إشعار كتابي للعامل قبل 60 يوماً على الأقل من تاريخ الإنهاء.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>أما إذا كان الأجر لا يدفع شهرياً فيجب على الطرف الذي يقرر إنهاء العقد (سواء كان العامل أو صاحب العمل) توجيه إشعار كتابي للطرف الآخر قبل 30 يوماً على الأقل من تاريخ الإنهاء.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 10: ساعات العمل الإضافية */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Clock className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل على ساعات العمل الإضافية</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  التعديلات الجديدة تسمح بتعويض العاملين عن ساعات العمل الإضافية بإجازات مدفوعة الأجر بدلاً من دفع مقابل مالي، وذلك بشرط موافقة العامل، عكس ما كان عليه في السابق أن يكون التعويض عن ساعات العمل الإضافية مقابل مالي فقط، هذا التعديل يهدف إلى تحقيق توازن أفضل بين العمل والحياة الشخصية للعاملين.
                </p>
              </div>
            </div>

            {/* Section 11: الإجازات الجديدة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات نظام العمل الجديد في الإجازات</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">إجازة الوفاة</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">تم إضافة إجازة الوفاة لمدة 3 أيام في حال وفاة الأخ أو الأخت.</p>
                </div>
                <div className="bg-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                  <h4 className="font-bold text-[#0a3a23] mb-2 sm:mb-3 text-sm sm:text-base">إجازة المولود</h4>
                  <p className="text-sm sm:text-base text-[#0a3a23]">تم تحديد إجازة لمدة 3 أيام للأب في حالة ولادة مولود له، خلال 7 أيام من تاريخ الولادة.</p>
                </div>
              </div>
            </div>

            {/* Section 12: إجازة الوضع */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <Users className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">تعديلات إجازة الوضع للمرأة الحامل</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-4 sm:p-6 rounded-lg sm:rounded-xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  بناءً على المادة 151 من النظام فقد مُدت إجازة الوضع للمرأة العاملة إلى 12 أسبوع بأجر كامل، في السابق كان 10 أسابيع فقط.
                </p>
                <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-700">
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>تلزم المرأة بأخذ 6 أسابيع من هذه الإجازة بعد الولادة وجوبياً، أما بقية الأسابيع الـ6 فلها أن توزعها كيفما تشاء سواء قبل الولادة أو بعدها.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>وفي حال قل المتبقي من مدة الإجازة عن (ستة) أسابيع نتيجة تأخر الوضع عن تاريخه المرجح، فتحتسب المدة المكملة لها إجازة دون أجر، وفي جميع الأحوال يحق للمرأة العاملة تمديد هذه الإجازة (شهراً) دون أجر.</span>
                  </li>
                  <li className="flex items-start gap-2 sm:gap-3">
                    <span className="w-2 h-2 bg-[#0a3a23] rounded-full mt-2 flex-shrink-0"></span>
                    <span>للمرأة في حالة إنجاب طفل مريض أو من ذوي الإعاقة تتطلب حالته الصحية مرافقاً مستمراً، الحق في إجازة مدتها (شهر) بأجر كامل تبدأ بعد انتهاء مدة إجازة الوضع، ولها الحق في تمديد الإجازة لمدة شهر دون أجر.</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Section 13: الخاتمة */}
            <div className="mb-8 sm:mb-12">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8 text-[#0a3a23]" />
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800">كيف ساعدت التعديلات الجديدة على حفظ حقوق الأطراف في العلاقة العمالية؟</h2>
              </div>
              
              <div className="bg-[#0a3a23]/10 p-6 sm:p-8 rounded-xl sm:rounded-2xl">
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  على صعيد العلاقة بين الأطراف فقد ساعدت في جعل العلاقة التعاقدية بين العامل وصاحب العمل أكثر عدالة ومراعاة للحقوق والواجبات للطرفين، وساعدت في جعل بيئة العمل أكثر استقراراً للموظف وزيادة إنتاجيته، والتحقق من التزام المنشآت بقوانين وأحكام نظام العمل، والتأكد من صحة بيانات العقود.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800 mb-4 sm:mb-6">
                  وعلى صعيد الخلافات العمالية فقد ساعدت على تقليل الخلافات والقضايا العمالية من خلال وضوح العلاقة التعاقدية، أيضاً التشديد في دفع الأجور في الأوقات المحددة بما يضمن حصول العمال على حقوقهم المالية دون اللجوء إلى النزاعات.
                </p>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed text-gray-800">
                  باختصار، تهدف التعديلات الجديدة إلى خلق سوق عمل متوازن ومنظم، يعزز الإنتاجية، ويحمي حقوق جميع الأطراف، ويساهم في تحقيق أهداف رؤية المملكة العربية السعودية 2030.
                </p>
              </div>
            </div>

            {/* Call to Action */}
            <div className="bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] p-6 sm:p-8 rounded-xl sm:rounded-2xl text-white text-center">
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-3 sm:mb-4">هل تحتاج استشارة في التعديلات الجديدة لنظام العمل؟</h3>
              <p className="text-white/90 mb-4 sm:mb-6 text-sm sm:text-base">
                تواصل مع شركة أنس للمحاماة للحصول على استشارة قانونية متخصصة في التعديلات الجديدة لنظام العمل
              </p>
              <a
                href="https://wa.me/966115115945?text=أريد استشارة قانونية في التعديلات الجديدة لنظام العمل"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-[#0a3a23] px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-bold hover:bg-gray-100 hover:shadow-lg transition-all duration-300 text-sm sm:text-base"
              >
                احجز استشارة الآن
              </a>
            </div>

            {/* Author Section */}
            <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#0a3a23]/10 to-[#0a3a23]/5 p-4 sm:p-6 rounded-lg sm:rounded-xl border-l-4 border-[#0a3a23]">
              <div className="flex items-center">
                <p className="text-sm sm:text-base text-[#0a3a23] font-semibold">
                  <strong>إعداد: نهى عمار</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Share Section */}
        <div className="mt-6 sm:mt-8 text-center">
          <div className="flex items-center justify-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <Share2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
            <span className="text-gray-600 font-semibold text-sm sm:text-base">شارك المقال</span>
          </div>
          <div className="flex justify-center gap-3 sm:gap-4">
            <a
              href="https://x.com/khayatlawfirm?t=jAXcLytECVDZ2DRxkSLPWg&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              تويتر
            </a>
            <a
              href="https://www.instagram.com/khayatlawfirm?igsh=MTRmNXByeDBnOGxucw=="
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#0a3a23] text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-[#0a3a23]/90 transition-colors text-sm sm:text-base"
            >
              انستجرام
            </a>
          </div>
        </div>
      </div>

      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/966115115945?text=أريد استشارة قانونية في التعديلات الجديدة لنظام العمل"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      <Footer />
    </div>
  );
};

export default BlogPost6;
